module.exports = "/images/expand-menu.svg?57743730a4d03f34b44a11e4938873b4";